/** `/c/$companyId/reports/open-items?side&asOf` — Back keeps the side and the date. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OpenItemsScreen } from "../reports/OpenItemsScreen";
import { SIDES } from "../reports/rows";

const search = z.object({
  side: z.enum(SIDES).optional().catch(undefined),
  asOf: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/reports/open-items")({
  validateSearch: (raw) => search.parse(raw),
  component: OpenItemsRoute,
});

function OpenItemsRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  const current = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <OpenItemsScreen
      companyId={companyId}
      search={current}
      onSearch={(next) => void navigate({ search: next })}
    />
  );
}
